import React, { useEffect, useState } from "react";
import "./Headerads.css";
import axios from "axios";

const Headerads = () => {
  const [fetchedData, setFetchedData] = useState([]);
  const [fetchedData1, setFetchedData1] = useState([]);

  const fetchdata = async () => {
    try {
      const response = await axios.get(
        "https://api.dremerz.net/api/Kalanjiyam_Advertisement_TopLeft"
      );
      console.log(response.data, "response.data");
      setFetchedData(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchdata1 = async () => {
    try {
      const response1 = await axios.get(
        "https://api.dremerz.net/api/Kalanjiyam_Advertisement_Prefooterad1"
      );
      console.log(response1.data, "response.data");
      const onTop = response1.data.filter((data) => data.showOnTop == true);
      setFetchedData1(onTop);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchdata();
    fetchdata1();
  }, []);

  return (
    <div className="container-fluid py-4">
      <div className="row">
        {/* Right Section - 4 Columns for 1 Image */}
        <div className="col-md-4">
          <div className="row g-3">
            {fetchedData1?.map((item, index) => (
              <div
                key={item.id || index}
                className="col-12 leftheaderads-card-container"
              >
                <div className="leftheaderads-card h-100">
                  <a href={item.banneradtitle}>
                    <img
                      src={`https://api.dremerz.net/uploads/${item.banneradimage}`}
                      alt="ads"
                      className="leftheaderads-card-img-top2"
                    />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="col-md-8">
          <div className="leftheaderads-scroll-container">
            <div className="leftheaderads-scroll-content">
              {fetchedData?.map((item, index) => (
                <div
                  key={item.id || index}
                  className="leftheaderads-card-container"
                >
                  <div className="leftheaderads-card h-100">
                    <a href={item.banneradtitle}>
                      <img
                        src={`https://api.dremerz.net/uploads/${item.banneradimage}`}
                        alt="ads"
                        className="leftheaderads-card-img-top1"
                        style={{ cursor: "pointer" }}
                      />
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Headerads;
